import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postAgent18 } from "./VipCommissionCRUD";
import { vipCommissionSlice } from "./VipCommissionSlice";

const { actions } = vipCommissionSlice;

export const clearVipCommissionList = () => (dispatch) => {
  dispatch(actions.vipCommissionListFetched({ data: null }));
};

export const fetchVipCommissionList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent18(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipCommissionListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipCommissionList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchVipCommissionEffList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent18(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.vipCommissionEffListFetched({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipCommissionEffList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const publishVipCommission = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent18(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipCommissionPublished());
          return response;
        }
      } else {
        throw new Error("Error api: publishVipCommission");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
